export const LAMBDA_API_ENDPOINT_URL = process.env.REACT_APP_LAMBDA_API_ENDPOINT_URL;
export const S3_ENDPOINT_URL = process.env.REACT_APP_S3_ENDPOINT_URL;

export const AUTH_ENDPOINT_URL = process.env.REACT_APP_AUTH_ENDPOINT_URL;
export const AUTH_CLIENT_ID = process.env.REACT_APP_AUTH_CLIENT_ID;